import React from 'react';
import { StyledStandardButton } from '../styles/Buttons';

export const StandardButton = ({children, background, disabled, onClick}: {children: React.ReactNode; background?: string; disabled?: boolean; onClick?: any}) => {  
  return (
    <StyledStandardButton disabled={disabled} background={background} onClick={onClick}>{children}</StyledStandardButton>
  )
}

